export default __webpack_public_path__ + "static/media/demo2.9ec1ca1f.png";